// extracted by mini-css-extract-plugin
export default {"host":"MainMenuItemIcon_host__RKb8C"};